import React, { useState } from 'react';
import logo from './images/logo.png';

function Navbar({ activePage }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navLinks = [
    { name: 'HOME', path: '/', key: 'home' },
    { name: 'WHAT WE DO', path: '/what-we-do', key: 'what-we-do' },
    { name: 'PROJECTS', path: '/projects', key: 'projects' },
    { name: 'BTS GALLERY', path: '/bts-projects', key: 'bts-project' },
    { name: 'FOUNDERS', path: '/founders', key: 'founders' },
    { name: 'CONTACT US', path: '/contact-us', key: 'contact-us' }
  ];

  return (
    <nav className={`navbar page-${activePage}`}>
      <div className="navbar-logo">
        {/* New Favicon Logo (Web & Mobile Home) */}
        <img src="/favicon%20without%20bg.png" className="navbar-logo-img logo-favicon" alt="VSHOTS Logo" />
        {/* Original Logo (Mobile Other Pages) */}
        <img src={logo} className="navbar-logo-img logo-original" alt="Shotts Logo" />

        <h1 className={`navbar-title ${activePage === 'home' ? 'mobile-home-hidden' : ''}`}>VSHOTS</h1>
      </div>

      {/* Desktop Navigation */}
      <div className="navbar-links-container">
        <div className="navbar-links">
          {navLinks.map(link => (
            <a
              key={link.key}
              href={link.path}
              className={activePage === link.key ? 'active' : ''}
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>

      {/* Mobile Menu Toggle */}
      <div className={`navbar-toggle ${activePage === 'home' ? 'mobile-home-hidden' : ''}`} onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      {/* Mobile Navigation */}
      <div className={`mobile-navbar-links ${isMenuOpen ? 'show' : ''}`}>
        {navLinks.map(link => (
          <a
            key={link.key}
            href={link.path}
            className={activePage === link.key ? 'active' : ''}
            onClick={closeMenu}
          >
            {link.name}
          </a>
        ))}
      </div>
    </nav>
  );
}

export default Navbar;